<template>
	<div>
		<footer>
			<div class="footLogo"  @click="openIndex">
				<img :src="logo" alt="">
			</div>
			<div class="more">
				<div class="moreTextBox">
					<div class="moreText" @click="go(1)">作品展示</div>
					<div class="moreText" @click="go(2)">获奖经历</div>
					<div class="moreText" @click="go(3)">加入我们</div>
					<div class="moreText" @click="go(4)">商务合作</div>
				</div>
				<div class="moreBottom">
					<p><span>{{companyAddress}}</span><span>Fax：{{companyCode}}</span><span>Tel：{{companyPhone}}</span></p>
				</div>
			</div>
			<div class="ma">
				<div class="weibo">
					<div class="weiboMa"><img :src="microblog" alt=""></div>
					<div class="maText">新浪微博</div>
				</div>
				<div class="weixin">
					<div class="weixinMa"><img :src="weChat" alt=""></div>
					<div class="maText">官方微信</div>
				</div>
			</div>
			<div class="beiAn">京ICP备14007868号-1</div>
		</footer>
	</div>
</template>

<script>
	export default {
		name: 'myfooter',
		data() {
			return {
				companyAddress: "", //地址
				companyPhone: "", //公司电话
				logo: "", //公司logo
				microblog: "", //微博图片
				weChat: "", //微信图片
				companyAddress: "", //公司地址
				companyCode: "", //公司邮编:"",//公司邮箱
				companyMail:"",//公司邮箱
				companyCode:"",//传真
			}
		},
		methods: {
			getOther() {
				this.$api.get(this.$httpApi + this.$path.INDEX_DATALIST).then(res => {
					console.log("底部数据", res.data);
					this.companyAddress = res.data.data.companyAddress; //地址
					this.companyPhone = res.data.data.companyPhone; //公司电话
					this.logo = res.data.data.logo; //公司logo
					this.microblog = res.data.data.microblog; //微博图片
					this.weChat = res.data.data.weChat; //微信图片
					this.companyMail = res.data.data.companyMail; //邮箱
					this.companyCode = res.data.data.companyCode; //邮箱
				}).catch(err => {})
			},
			go(ele){
				if(ele===1){
					this.$router.push({name:'work'})
					this.$store.state.isActive="work"
					localStorage.setItem("ishot","work")
				}else if(ele===2){
					this.$router.push({path:"/dynamic",query:{num:2}})
					this.$store.state.isActive="dynamic"
					localStorage.setItem("ishot","dynamic")
				}else if(ele===3){
					this.$router.push({name:'join',query:{num:3}})
					this.$store.state.isActive="join"
					localStorage.setItem("ishot","join")
				}else if(ele===4){
					this.$router.push({path:"/about",query:{num:4}})
					this.$store.state.isActive="about"
					localStorage.setItem("ishot","about")
				}
			},
			//打开首页
			openIndex() {
				// this.ishot='index',
				this.$store.state.isActive = "index"
				this.$router.push({
					path: '/'
				})
				localStorage.setItem("ishot", "index")
			},
		},
		mounted() {
			//获取其他信息接口
			this.getOther()
		}
	}
	
</script>

<style scoped>
	footer {
		width: 19.20rem;
		height: 5.07rem;
		background: #0F0F0F;
		border-top: 0.02rem solid #BFBFBF;
		padding: 1.90rem 1.40rem 0 1.40rem;
		box-sizing: border-box;
		position: relative;
	}

	.footLogo {
		width: 3.02rem;
		height: 0.72rem;
		cursor: pointer;
		float: left;
	}

	.footLogo img {
		width: 100%;
		height: 100%;
	}

	.more {
		width: 10.50rem;
		height: 1.50rem;
		float: left;
	}

	.moreTextBox {
		width: 100%;
		height: 0.72rem;
		padding: 0 1.00rem;
		box-sizing: border-box;
		cursor: pointer;
		margin-bottom: 0.04rem;
	}

	.moreText {
		width: 2.10rem;
		height: 0.72rem;
		color: #ffffff;
		float: left;
		font-size: 0.21rem;
		text-align: center;
		line-height: 0.72rem;
		
	}
    .moreText:hover{
	    color: #BA0303;
    }
	.moreBottom {
		width: 100%;
		height: 0.20rem;

	}
     .moreBottom p{
		 width: 100%;
		 font-size: 0.18rem;
		 line-height: 0.18rem;
		 color: #b5b5b5;
	 }
	.moreBottom span {
		font-size: 0.18rem;
		margin: 0 0.20rem;
	}

	.ma {
		width: 2.50rem;
		height: 1.50rem;
		float: right;
	}

	.weixin,
	.weibo {
		width: 0.88rem;
		height: 1.50rem;
		float: right;
		margin-left: 0.33rem;
	}

	.weixinMa,
	.weiboMa {
		width: 0.88rem;
		height: 0.88rem;
	}

	.weixinMa img,
	.weiboMa img {
		width: 100%;
		height: 100%;
	}

	.maText {
		width: 100%;
		height: 0.18rem;
		font-size: 0.18rem;
		line-height: 0.18rem;
		color: #ffffff;
		text-align: center;
		margin-top: 0.20rem;
	}

	.beiAn {
		width: 100%;
		height: 0.18rem;
		position: absolute;
		left: 0;
		bottom: 0.45rem;
		text-align: center;
		color: #ffffff;
		font-size: 0.18rem;
	}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue